export default async function (nextId) {
  // nextId()
  // can return object like { identifier: ..., name: ... }
  // name is not mandatory
  return null
}
